import './CommentDisplay.scss';
import { CommentAuthor } from './CommentAuthor';
import { Comment as CommentBase } from '@ant-design/compatible';
import { Editor } from '@ui/Editor';
import { SanitizedHtml } from '@ui/general';
import { SonarUser } from '@ui/SonarUser';
import { coreActions } from '@sonar-software/sonar-core';
import React, { useCallback } from 'react';
import { useAction, useToggle } from '@hooks';
export const CommentDisplay = ({ comment }) => {
    const [isEditing, toggleEditing] = useToggle(false);
    const remove = useAction(coreActions.requestDeleteCoreInitiativesCommentsById);
    const update = useAction(coreActions.requestPatchCoreInitiativesCommentsById);
    const { addedBy, addedOn, body, bodyHtml, id, initiativeId } = comment;
    const handleDelete = useCallback(() => remove({
        id,
        initiativeId
    }), [id, initiativeId, remove]);
    const handleOnSaveClick = useCallback((updatedBody, updatedBodyHtml, taggedUsers) => {
        update({
            body: updatedBody,
            bodyHtml: updatedBodyHtml,
            id: comment.id,
            initiativeId: comment.initiativeId,
            taggedUsers
        });
        toggleEditing();
    }, [comment.id, comment.initiativeId, toggleEditing, update]);
    const displayContent = isEditing ?
        React.createElement(Editor, { bordered: true, content: body, editing: true, enableMentions: true, onCancel: toggleEditing, onSave: handleOnSaveClick }) :
        React.createElement(SanitizedHtml, { html: bodyHtml });
    return (React.createElement(CommentBase, { author: React.createElement(CommentAuthor, { authorUserId: addedBy, commentId: id, createDate: addedOn, onDelete: handleDelete, onEdit: toggleEditing }), avatar: React.createElement(SonarUser, { userId: addedBy, withFullName: false }), className: 'initiative-comment', content: displayContent }));
};
